import type { AssessmentQuestion } from '@ts-assessment/interfaces'

import { AssessmentTopics } from '@ts-assessment/enums'

import imgQuestion1 from '@images/assessment/questions/ela/grade-k3/question-1.png'
import imgQuestion9 from '@images/assessment/questions/ela/grade-k3/question-9.png'
import imgQuestion12 from '@images/assessment/questions/ela/grade-k3/question-12.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k3_1',
    title: 'Which word has the same beginning sound as “school”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k3_1_a',
        text: 'spoon',
      },
      {
        name: 'grade_k3_1_b',
        text: 'cool',
      },
      {
        name: 'grade_k3_1_c',
        text: 'skate',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_2',
    title: 'If someone says, “Can you please help me?” what should you say?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k3_2_a',
        text: 'No, I can’t.',
      },
      {
        name: 'grade_k3_2_b',
        text: 'Yes, I can help you.',
        correct: true,
      },
      {
        name: 'grade_k3_2_c',
        text: 'I don’t know.',
      },
    ],
  },
  {
    name: 'grade_k3_3',
    title: 'If your friend says, “I’m feeling sad today,” what is a kind thing to say?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k3_3_a',
        text: 'That’s funny.',
      },
      {
        name: 'grade_k3_3_b',
        text: 'Do you want to talk about it?',
        correct: true,
      },
      {
        name: 'grade_k3_3_c',
        text: 'Ignore them.',
      },
    ],
  },
  {
    name: 'grade_k3_4',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“Emma carefully placed the small, delicate vase on the shelf so it wouldn’t fall and break.”',
    sentence: 'Why did Emma place the vase carefully?',
    answers: [
      {
        name: 'grade_k3_4_a',
        text: 'She wanted it to look pretty.',
      },
      {
        name: 'grade_k3_4_b',
        text: 'So it wouldn\'t stop being.',
        correct: true,
      },
      {
        name: 'grade_k3_4_c',
        text: 'Because it was heavy.',
      },
    ],
  },
  {
    name: 'grade_k3_5',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The disciplines were excited to visit the zoo and see animals they had only read about in books.”',
    sentence: 'Why were the disciplines excited?',
    answers: [
      {
        name: 'grade_k3_5_a',
        text: 'They didn’t like books.',
      },
      {
        name: 'grade_k3_5_b',
        text: 'They wanted to see real animals.',
        correct: true,
      },
      {
        name: 'grade_k3_5_c',
        text: 'They were tired.',
      },
    ],
  },
  {
    name: 'grade_k3_6',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“After the long hike, Carlos drank water and rested under the shade of a tall tree.”',
    sentence: 'What did Carlos do after the hike?',
    answers: [
      {
        name: 'grade_k3_6_a',
        text: 'He kept hiking.',
      },
      {
        name: 'grade_k3_6_b',
        text: 'He climbed the tree.',
      },
      {
        name: 'grade_k3_6_c',
        text: 'He drank water and rested.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_7',
    title: 'Which sentence is written correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k3_7_a',
        text: 'the cat chased the mouse all day.',
      },
      {
        name: 'grade_k3_7_b',
        text: 'The cat chased the mouse all day.',
        correct: true,
      },
      {
        name: 'grade_k3_7_c',
        text: 'The Cat chased the mouse all day',
      },
    ],
  },
  {
    name: 'grade_k3_8',
    title: 'Choose the best way to complete this sentence:',
    detail: 'Yesterday, I ______ to the park with my friends.',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k3_8_a',
        text: 'goed',
      },
      {
        name: 'grade_k3_8_b',
        text: 'going',
      },
      {
        name: 'grade_k3_8_c',
        text: 'went',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_9',
    title: 'Choose the sentence that has the most informative description:',
    topic: AssessmentTopics.Writing,
    image: imgQuestion9,
    answers: [
      {
        name: 'grade_k3_9_a',
        text: 'The dog runs.',
      },
      {
        name: 'grade_k3_9_b',
        text: 'The dog runs fast.',
      },
      {
        name: 'grade_k3_9_c',
        text: 'The big, brown dog runs fast in the park.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_10',
    title: 'Which word is a noun in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The students played soccer on the field.',
    answers: [
      {
        name: 'grade_k3_10_a',
        text: 'played',
      },
      {
        name: 'grade_k3_10_b',
        text: 'students',
        correct: true,
      },
      {
        name: 'grade_k3_10_c',
        text: 'on',
      },
    ],
  },
  {
    name: 'grade_k3_11',
    title: 'Which sentence uses the past tense correctly?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k3_11_a',
        text: 'She run to the store yesterday.',
      },
      {
        name: 'grade_k3_11_b',
        text: 'She runs to the store yesterday.',
      },
      {
        name: 'grade_k3_11_c',
        text: 'She ran to the store yesterday.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_12',
    title: 'Which word is an adjective in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The bright sun shined all day.',
    image: imgQuestion12,
    answers: [
      {
        name: 'grade_k3_12_a',
        text: 'bright',
        correct: true,
      },
      {
        name: 'grade_k3_12_b',
        text: 'sun',
      },
      {
        name: 'grade_k3_12_c',
        text: 'shined',
      },
    ],
  },
]
